/* file description */
import { FormFrom } from '../../SPForm';

// valueType枚举
export enum VALUE_TYPES {
  TEXT = 'text',
  TEXTAREA = 'textarea',
  DIGIT = 'digit',
  PASSWORD = 'password',
  SELECT = 'select',
  MONEY = 'money',
  INDEX = 'index',
  CHECKBOX = 'checkbox',
  SWITCH = 'switch',
  RADIO = 'radio',
  DATE = 'date',
  DATE_RANGE = 'dateRange',
  TIME = 'time',
  TIME_RANGE = 'timeRange',
  DATE_TIME = 'dateTime',
  DATE_TIME_RANGE = 'dateTimeRange',
  UPLOAD = 'upload',
}

// select mode 枚举
export enum SELECT_MODE {
  MULTIPLE = 'multiple',
  TAGS = 'tags',
}

// 低代码Kind枚举
export enum LCP_FIELD_KINDS {
  STRING = 'String',
  EMAIL = 'Email',
  URL = 'Url',
  NUMBER = 'Number',
  PHONE = 'Phone',
  SELECT = 'Select',
  RECORD_SELECT = 'RecordSelect',
  BOOL = 'Bool',
  CHECKBOX = 'Checkbox',
  DATE_TIME = 'DateTime',
  BOULDERAI_ROLE = 'BoulderaiRole',
  BOULDERAI_USER = 'BoulderaiUser',
  RECORD = 'Record',
  FILE = 'File',
  REFERENCE = 'Reference',
  TEXT = 'Text',
  AREA_SELECT = 'AreaSelect',
  ASEET_CHECKBOX = 'AseetCheckbox',
  ASEET_RADIO = 'AseetRadio',
  QRCODE = 'QrCode',
  ASSET_BOOL = 'AssetBool',
  ASSET_DATETIME = 'AssetDateTime',
  DEPUSER = 'DepUser',
  PRODUCTSELECT = 'ProductSelect',
  OPENAPI_SELECT = 'OpenApiSelect',
}

// 额外扩展类型枚举 (如联动展示字段等)
export enum LCP_EFECT_KINDS {
  LINK_SHOW_RECORD = 'LinkShowRecord',
}


// 来自于table的column还是来自于form，需和FormFrom 对应
export enum COLUMN_FROM {
  TABLE = 'table',
  FORM = 'form',
  SEARCH = 'search',
}
